import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Merge = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.15796 3.57434C1.15796 3.2982 1.38182 3.07434 1.65796 3.07434H3.29531C4.6262 3.07434 5.84194 3.82917 6.43222 5.022L8.27996 8.75585C8.70159 9.60787 9.56997 10.147 10.5206 10.147H10.8973V8.89103C10.8973 8.50238 11.3213 8.26233 11.6545 8.46228L14.5994 10.2292C14.9231 10.4234 14.9231 10.8925 14.5994 11.0867L11.6545 12.8536C11.3213 13.0535 10.8973 12.8135 10.8973 12.4248V11.147H10.5206C9.18971 11.147 7.97398 10.3922 7.3837 9.19937L5.53596 5.46553C5.11433 4.6135 4.24595 4.07434 3.29531 4.07434H1.65796C1.38182 4.07434 1.15796 3.85048 1.15796 3.57434ZM1.65797 10.0743H6.15797C6.43411 10.0743 6.65797 10.2982 6.65797 10.5743C6.65797 10.8505 6.43411 11.0743 6.15797 11.0743L1.65797 11.0743C1.38182 11.0743 1.15797 10.8505 1.15797 10.5743C1.15797 10.2982 1.38182 10.0743 1.65797 10.0743Z"
        fill={color}
      />
    </svg>
  )
})

export default Merge
